
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Checkbox } from "@/components/ui/checkbox"
import { UseFormReturn } from "react-hook-form"
import { FormValues } from "../schema"
import { useEffect } from "react"

interface TermsFieldProps {
  form: UseFormReturn<FormValues>
}

export function TermsField({ form }: TermsFieldProps) {
  // Watch for changes to the membershipType field
  const membershipType = form.watch("membershipType");
  const isDonor = membershipType === "donor";
  
  // Debug logs
  console.log("DEBUG TermsField - Initial membershipType from form:", membershipType);
  console.log("DEBUG TermsField - isDonor:", isDonor);
  
  useEffect(() => {
    console.log("EFFECT: TermsField updated with membershipType:", membershipType);
    console.log("EFFECT: TermsField isDonor:", isDonor);
  }, [membershipType, isDonor]);
  
  return (
    <div className="space-y-4">
      {/* Only show Terms acceptance and French citizenship declaration for Active and Benefactor members */}
      {!isDonor && (
        <>
          <FormField
            control={form.control}
            name="acceptTerms"
            render={({ field }) => (
              <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    required={!isDonor}
                  />
                </FormControl>
                <div className="space-y-1 leading-none">
                    <FormLabel>
                      J'accepte les conditions d'adhésion
                    </FormLabel>
                    <FormDescription>
                      En cochant cette case, je reconnais avoir pris connaissance des statuts de l'association et je m'engage à les respecter.
                    </FormDescription>
                  </div>
                  <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="declareFrenchCitizen"
            render={({ field }) => (
              <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
                <FormControl>
                  <Checkbox
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    required={!isDonor}
                  />
                </FormControl>
                <div className="space-y-1 leading-none">
                  <FormLabel>
                    Je déclare être majeur(e) et citoyen(ne) français(e)
                  </FormLabel>
                  <FormDescription>
                    Cette déclaration est obligatoire pour devenir membre de l'association.
                  </FormDescription>
                </div>
                <FormMessage />
              </FormItem>
            )}
          />
        </>
      )}
      
      <FormField
        control={form.control}
        name="acceptNewsletter"
        render={({ field }) => {
          console.log("RENDER: Newsletter checkbox rendering with value:", field.value);
          return (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
              <FormControl>
                <Checkbox
                  checked={field.value || false}
                  onCheckedChange={field.onChange}
                  id="accept-newsletter"
                />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel htmlFor="accept-newsletter">
                  Je souhaite recevoir la newsletter
                </FormLabel>
                <FormDescription>
                  Vous pouvez vous désabonner à tout moment en cliquant sur le lien de désabonnement présent dans nos emails.
                </FormDescription>
              </div>
            </FormItem>
          );
        }}
      />
    </div>
  );
}
